const isTrueString = (value) =>
  typeof value === "string" && value.trim().toLowerCase() === "true";

export const isCharacterCardDiscontinuedFromPacks = (card) => {
  if (!card) return false;
  return card.discontinuedFromPacks === true || isTrueString(card.discontinuedFromPacks);
};

export const isCharacterCardEligibleForFuturePacks = (card) =>
  !isCharacterCardDiscontinuedFromPacks(card);

export const filterPackEligibleCharacterCards = (cards = []) =>
  (Array.isArray(cards) ? cards : []).filter(isCharacterCardEligibleForFuturePacks);
